export function getMissingRequiredQuestions(quiz, answers) {
  return quiz.questions.filter((question) => {
    if (!question.required) {
      return false;
    }

    const answer = answers[question.id];
    return Array.isArray(answer) ? !answer.length : !answer;
  });
}

export function scoreResults(quiz, answers) {
  const scores = {};
  const resultMap = {};
  const eliminated = getEliminatedResults(quiz, answers);

  quiz.results.forEach((result) => {
    scores[result.id] = 0;
    resultMap[result.id] = result;
  });

  quiz.questions.forEach((question) => {
    const selected = answers[question.id];
    const selectedIds = Array.isArray(selected) ? selected : [selected];

    (question.options || []).forEach((option) => {
      if (selectedIds.indexOf(option.id) === -1 || !option.scores) {
        return;
      }

      Object.keys(option.scores).forEach((resultId) => {
        if (typeof scores[resultId] === "number") {
          scores[resultId] += Number(option.scores[resultId]) || 0;
        }
      });
    });
  });

  return Object.keys(scores)
    .filter((resultId) => !eliminated[resultId])
    .map((resultId) => {
      const result = Object.assign({}, resultMap[resultId]);
      result.score = scores[resultId];
      return result;
    })
    .sort((a, b) => b.score - a.score);
}

export function hasAvailableResults(quiz, answers) {
  const eliminated = getEliminatedResults(quiz, answers);

  return quiz.results.some((result) => !eliminated[result.id]);
}

function getEliminatedResults(quiz, answers) {
  const eliminated = {};

  quiz.questions.forEach((question) => {
    const selected = answers[question.id];
    const selectedIds = Array.isArray(selected) ? selected : [selected];

    (question.options || []).forEach((option) => {
      if (selectedIds.indexOf(option.id) === -1 || !Array.isArray(option.eliminates)) {
        return;
      }

      option.eliminates.forEach((resultId) => {
        eliminated[resultId] = true;
      });
    });
  });

  return eliminated;
}
